import * as web from './web';
import storage from 'store';


export default {
	web,
	storage
};
